import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=700de554&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700de554",
  null
  
)

export default component.exports